class QueryBuilder
  constructor: (initialQuery)->
    @queryBuilder = {
      filterQuery: initialQuery or ''
      totalSelections: 0
    }

    @extend = (catFacetsToAdd) ->
      if catFacetsToAdd.foundCats.length
        @queryBuilder.filterQuery += " AND (#{catFacetsToAdd.catQuery})"
        @queryBuilder.totalSelections += catFacetsToAdd.foundCats.length
      return @

    @extendSimple = (arrayOfSelections, filterToAdd) ->
      if arrayOfSelections.length
        @queryBuilder.filterQuery += filterToAdd
        @queryBuilder.totalSelections += arrayOfSelections.length
      return @

    @finalize = (arrayOfSelections, filterToAdd) ->
      @queryBuilder.filterQuery = @queryBuilder.filterQuery.replace(/^\s+(AND|OR)\s+/,'')
      return @queryBuilder

module.exports = QueryBuilder
